import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import Entreprises from './pages/Entreprises';
import Gateaux from './pages/Gateaux';
import CreationsPage from './pages/CreationsPage';
import Contact from './pages/Contact';
import NotreCarte from './pages/NotreCarte';

import MonCompte from './pages/MonCompte';
import Checkout from './pages/Checkout';
import Legal from './pages/Legal';
import Privacy from './pages/Privacy';

import AdminDashboard from './pages/AdminDashboard';
import AdminRoute from './components/AdminRoute';
import { CartProvider } from './context/CartContext';
import CartSidebar from './components/CartSidebar';
import { FavoritesProvider } from './context/FavoritesContext';
import FavoritesSidebar from './components/FavoritesSidebar';
import QuickActions from './components/QuickActions';
import SplashScreen from './components/SplashScreen';
import { SettingsProvider } from './context/SettingsContext';
import CookieBanner from './components/CookieBanner';

// Scroll to top on route change
function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function App() {
  return (
    <SettingsProvider>
      <FavoritesProvider>
        <CartProvider>
          <Router>
            <div className="App">
              <SplashScreen />
              <ScrollToTop />
              <Navbar />
              <CartSidebar />
              <FavoritesSidebar />
              <QuickActions />
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/entreprises" element={<Entreprises />} />
                <Route path="/gateaux" element={<Gateaux />} />
                <Route path="/notre-carte" element={<NotreCarte />} />
                <Route path="/nos-creations" element={<CreationsPage />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/mon-compte" element={<MonCompte />} />
                <Route path="/checkout" element={<Checkout />} />
                <Route path="/mentions-legales" element={<Legal />} />
                <Route path="/confidentialite" element={<Privacy />} />

                {/* Admin Routes */}
                <Route element={<AdminRoute />}>
                  <Route path="/admin" element={<AdminDashboard />} />
                </Route>
              </Routes>
              <Footer />
              <CookieBanner />
            </div>
          </Router>
        </CartProvider>
      </FavoritesProvider>
    </SettingsProvider>
  );
}

export default App;
